import React from 'react';
import MetersIndexPage from '../meters_index_page/MetersIndexPage';

export default function MetersArchivedIndexPage() {
	return (
		<MetersIndexPage
			preAppliedFilters={{ isArchived: 'true' }}
			targetCollectionName="archivedMetersIndex"
		/>
	);
}
